import React from "react";
import { Box, Skeleton, Stack } from "@mui/material";

const ProductCardSkeleton = () => {
  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        cursor: "pointer",
        borderRadius: 2,
        bgcolor: "text.lightGrey",
      }}
    >
      <Box position="relative" overflow="hidden">
        {/* Image Skeleton */}
        <Skeleton variant="rectangular" width="100%" height={220} />
      </Box>

      <Stack p={1} >
        <Skeleton
          variant="text"
          width="60%"
          height={30}
          // sx={{ marginBottom: 0.5 }}
        />

        {/* Name Skeleton */}
        <Skeleton
          variant="text"
          width="80%"
          height={30}
          sx={{ marginBottom: 0.5 }}
        />
        <Skeleton
          variant="text"
          width="80%"
          height={30}
          sx={{ marginBottom: 0.5 }}
        />

        {/* Rating Skeleton */}
        <Skeleton
          variant="rectangular"
          width="40%"
          height={20}
          sx={{ marginBottom: 1 }}
        />
      </Stack>
    </Box>
  );
};

export default ProductCardSkeleton;
